"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var pageLoader_1 = require("@vidazoo/ui/lib/components/pageLoader");
exports.default = (function (_a) {
    var _b = _a.message, message = _b === void 0 ? "" : _b, others = tslib_1.__rest(_a, ["message"]);
    return (React.createElement("div", { className: "spread flex align-center justify-center" },
        React.createElement(pageLoader_1.PageLoader, tslib_1.__assign({}, others, { message: message }))));
});
